import { Card } from "@mui/material";

export default function CustomCard(props) {
  const borRadius = props.radius || "24px";
  const shadowPercent = props.shadowpercent || "";
  return (
    <Card
      {...props}
      sx={{
        borderRadius: borRadius,
        boxShadow: `0 4px 16px 0 rgb(0 0 0 / ${shadowPercent || ".16"})`,
        padding: "32px 24px",
        ...props.sx,
      }}
    >
      {props.children}
    </Card>
  );
}
